import { ExtendedGridColDef } from '@/types/ExtendedGridColDef';
import { FC, useEffect, useState } from 'react';
import { SCUIBreadCrumb, SCUICustomDataGrid } from '../../../atomic/molecules';
import { Dialog, DialogContent, DialogTitle, IconButton, Tooltip } from '@mui/material';
import { SCUIButton } from '../../../atomic/atoms';
import CloseIcon from '@mui/icons-material/Close';
import ExpenseNoteQuery from '../../../services/query/expenseNote/ExpenseNote.services';
import Swal from 'sweetalert2';
import TimeHelper from '../../../utils/time';
import { useTranslation } from 'react-i18next';
import { EXPNOTEGRID, expnoteCls } from '../expenseNote.classes';

interface IProps {
    props: any;
}
export const ExpenseNoteDataGrid: FC<IProps> = ({ props }) => {
    const [pdfUrl, setPdfUrl] = useState<string | null>(null);
    const [openModal, setOpenModal] = useState<boolean>(false);
    const { t } = useTranslation();

    useEffect(() => {
        props.ListExpenseNote();
    }, [props.pageNumber, props.pageSize]);

    const createPdfBlobUrl = (base64String: string) => {
        const byteCharacters = atob(base64String);
        const byteNumbers = new Array(byteCharacters.length);

        for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
        }

        const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray], { type: 'application/pdf' });

        return URL.createObjectURL(blob);
    };

    // Önizleme için kullanılan fonksiyon
    const handlePreviewExpenseNote = (shipmentId: any) => {
        let req = { shipmentId: shipmentId };
        ExpenseNoteQuery.PreviewExpenseVoucher(req)
            .then((response: any) => {
                if (response.isSuccess && response.base64String) {
                    const blobUrl = createPdfBlobUrl(response.base64String);
                    setPdfUrl(blobUrl);
                    setOpenModal(true);
                } else {
                    Swal.fire('Hata', response.errorMessage || 'Base64 string boş ya da geçersiz.', 'error');
                    return;
                }
            })
            .catch((error: any) => {
                Swal.fire('Hata', error, 'error');
            });
    };

    // Yazdırma için kullanılan fonksiyon
    const handlePrintExpenseNote = (shipmentId: any) => {
        Swal.fire({
            title: 'Uyarı',
            text: 'Gider Pusulası yazdırmak istediğinize emin misiniz?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: t('general.yes'),
            cancelButtonText: t('general.no'),
        }).then((result) => {
            if (result.isConfirmed) {
                let req = { shipmentId: shipmentId };
                ExpenseNoteQuery.CreateExpenseVoucher(req)
                    .then((response: any) => {
                        if (response.isSuccess && response.base64String) {
                            const blobUrl = createPdfBlobUrl(response.base64String);
                            window.open(blobUrl, '_blank');
                        } else {
                            Swal.fire('Hata', response.errorMessage || 'Base64 string boş ya da geçersiz.', 'error');
                            return;
                        }
                    })
                    .catch((error: any) => {
                        Swal.fire('Hata', error, 'error');
                    });
            }
        });
    };
    const handleCloseModal = () => {
        setOpenModal(false);
        setPdfUrl(null);
    };
    const columns: ExtendedGridColDef[] = [
        {
            field: 'orderNumber',
            headerName: t('general.orderNo'),
            flex: 1,
            headerAlign: 'center',
            align: 'center',
            renderCell: (params: any) => {
                return (
                    <div className={EXPNOTEGRID.cellWrapOrder}>
                        <Tooltip title={params.row.orderNumber}>
                            <a
                                target="_blank"
                                className={expnoteCls('linktxt', EXPNOTEGRID.cellLinkOrder)}
                                href={'/orderdetail?OrderNumber=' + params.row.orderNumber}
                                rel="noreferrer"
                            >
                                {params.row.orderNumber}
                            </a>
                        </Tooltip>
                    </div>
                );
            },
        },
        {
            field: 'shipmentNumber',
            headerName: t('general.shippingNo'),
            flex: 1,
            headerAlign: 'center',
            align: 'center',
            renderCell: (params: any) => {
                return (
                    <div className={EXPNOTEGRID.cellWrapShipment}>
                        <Tooltip title={params.row.shipmentNumber}>
                            <a
                                target="_blank"
                                className={expnoteCls('linktxt', EXPNOTEGRID.cellLinkShipment)}
                                href={'/orderdetail?shippingListNo=' + params.row.shipmentNumber}
                                rel="noreferrer"
                            >
                                {params.row.shipmentNumber}
                            </a>
                        </Tooltip>
                    </div>
                );
            },
        },
        {
            field: 'no',
            headerName: 'Pusula No',
            flex: 1,
            headerAlign: 'center',
            align: 'center',
            renderCell: (params: any) => {
                return (
                    <div className={EXPNOTEGRID.cellTextNo}>
                        <Tooltip title={params.row.no}>
                            <p>{params.row.no}</p>
                        </Tooltip>
                    </div>
                );
            },
        },
        {
            field: 'date',
            headerName: 'Gider Pusulası Tarihi',
            flex: 1,
            headerAlign: 'center',
            align: 'center',
            renderCell: (params: any) => {
                return (
                    <div className={EXPNOTEGRID.cellTextDate}>
                        {params.row.date && params.row.date.length > 0 ? (
                            <Tooltip title={TimeHelper.formatDate(params.row.date)}>
                                <p>{TimeHelper.formatDate(params.row.date)}</p>
                            </Tooltip>
                        ) : (
                            <p>-</p>
                        )}
                    </div>
                );
            },
        },
        {
            field: 'printStatus',
            headerName: 'Statü',
            flex: 1,
            headerAlign: 'center',
            align: 'center',
            renderCell: (params: any) => {
                return (
                    <div className={EXPNOTEGRID.cellTextStatus}>
                        {params.row.printStatus === true ? (
                            <Tooltip title={'Yazdırıldı'}>
                                <p>Yazdırıldı</p>
                            </Tooltip>
                        ) : (
                            <Tooltip title={'Yazdırılmayı Bekliyor'}>
                                <p>Yazdırılmayı bekliyor</p>
                            </Tooltip>
                        )}
                    </div>
                );
            },
        },
        {
            field: 'print',
            headerName: 'Yazdır',
            flex: 1,
            headerAlign: 'center',
            align: 'center',
            renderCell: (params: any) => {
                return (
                    <div>
                        <Tooltip title={params.row.print}>
                            <SCUIButton
                                className={EXPNOTEGRID.inputButtonPrintRow}
                                text="Yazdır"
                                sizeType="fixed"
                                type="secondary"
                                size={'s'}
                                onClick={() => {
                                    handlePrintExpenseNote(params.row.shipmentId);
                                    props.ListExpenseNote();
                                }}
                            />
                        </Tooltip>
                    </div>
                );
            },
        },
        {
            field: 'printedDateStr',
            headerName: 'Yazdırılma Tarihi',
            flex: 1,
            headerAlign: 'center',
            align: 'center',
            renderCell: (params: any) => {
                return (
                    <div className={EXPNOTEGRID.cellPrintedDate}>
                        {params.row.printedDate && params.row.printedDate.length > 0 ? (
                            <Tooltip title={TimeHelper.formatDate(params.row.printedDate)}>
                                <p>{TimeHelper.formatDate(params.row.printedDate)}</p>
                            </Tooltip>
                        ) : (
                            <p>-</p>
                        )}
                    </div>
                );
            },
        },
        {
            field: 'shipmentId',
            headerName: 'Belge Görüntüle',
            flex: 1,
            headerAlign: 'center',
            align: 'center',
            renderCell: (params: any) => {
                return (
                    <div className={expnoteCls('cursorPointer', EXPNOTEGRID.previewCellWrap)}>
                        <SCUIButton
                            className={EXPNOTEGRID.inputButtonPreview}
                            text={'Belge Ön İzleme'}
                            sizeType="fixed"
                            type="primary"
                            size={'s'}
                            onClick={() => {
                                handlePreviewExpenseNote(params.row.shipmentId);
                            }}
                        />
                    </div>
                );
            },
        },
    ];
    return (
        <div className={EXPNOTEGRID.section}>
            <div className={EXPNOTEGRID.breadcrumbWrap}>
            <SCUIBreadCrumb
                title={'Gider Pusulası Sayfası'}
                componentLink={'/expenseNote'}
                style={{ cursor: 'pointer' }}
                onClick={() => {
                    props.ListExpenseNote();
                }}
            />
            </div>
            <div className={EXPNOTEGRID.gridWrap}>
            <SCUICustomDataGrid
                randomId
                rows={props.rows || []}
                columns={columns}
                onPageSizeChange={(i: number) => {
                    props.setPageSize(i);
                }}
                pageSize={props.pageSize}
                paginationModeChange
                onPageChange={(i: number) => {
                    props.setPageNumber(i);
                }}
                page={props.pageNumber}
                rowCount={props.rowCount}
                excelDownloadButton={true}
            />
            </div>

            {/* PDF Preview Modal */}
            <Dialog className={EXPNOTEGRID.pdfDialog} open={openModal} onClose={handleCloseModal} fullWidth maxWidth="md">
                <DialogTitle className={EXPNOTEGRID.pdfDialogTitle}>
                    PDF Önizleme
                    <IconButton
                        edge="end"
                        color="inherit"
                        onClick={handleCloseModal}
                        aria-label="close"
                        style={{ position: 'absolute', right: 8, top: 8 }}
                    >
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <DialogContent>
                    {pdfUrl && (
                        <div className={expnoteCls('pdf-preview-container', EXPNOTEGRID.pdfEmbedWrap)}>
                            <embed
                                src={pdfUrl}
                                type="application/pdf"
                                className={expnoteCls('pdf-preview-embed', EXPNOTEGRID.pdfEmbed)}
                                title="PDF Preview"
                                width="100%"
                                height="600px"
                            />
                        </div>
                    )}
                </DialogContent>
            </Dialog>
        </div>
    );
};
